/**
 * Pure render helpers for the bundle PDP component list.
 *
 * No DOM / window access — safe to require() in Node tests and to load in the
 * browser (attaches to window.StockedBundleComponents). The browser custom
 * element (bundle-components.js) feeds normalized component objects in.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.StockedBundleComponents = api;
})(typeof self !== 'undefined' ? self : this, function () {
  var CDN_BASE = 'https://cdn.shopify.com/s/files/1/0512/1871/0728/files/';
  var SPECIAL_BADGES = {
    'dairy-free': 'badge-dairy-free.svg',
    'nut-free': 'badge-nut-free.svg',
    'gluten-free': 'badge-gluten-free.svg',
  };

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function slugify(name) {
    return name.toLowerCase().replace(/[^a-z0-9]/g, '-');
  }

  function allergenIcons(allergensString) {
    var names = String(allergensString || '')
      .split(',')
      .map(function (a) { return a.trim(); })
      .filter(Boolean);
    if (!names.length) return '';

    var items = names.map(function (name) {
      var slug = slugify(name);
      var fileName = SPECIAL_BADGES[slug] || ('icon-' + slug + '.svg');
      var extraClass = SPECIAL_BADGES[slug] ? ('badge-' + slug) : '';
      var cls = ('svg-wrapper' + (extraClass ? ' ' + extraClass : '')).trim();
      return (
        '<li class="allergen-option-item">' +
        '<span class="visually-hidden">' + escapeHtml(name) + '</span>' +
        '<img src="' + escapeHtml(CDN_BASE + fileName) + '" alt="' + escapeHtml(name) + '" class="' + cls + '">' +
        '</li>'
      );
    }).join('');

    return '<ul class="allergen-options bundle-components__allergens">' + items + '</ul>';
  }

  function componentRow(component, options) {
    component = component || {};
    options = options || {};
    var showImages = options.showImages !== false;

    var titleText = escapeHtml(component.title || '');
    var nameHtml = component.url
      ? '<a class="bundle-components__name" href="' + escapeHtml(component.url) + '">' + titleText + '</a>'
      : '<span class="bundle-components__name">' + titleText + '</span>';

    var imageHtml = '';
    if (showImages) {
      imageHtml = component.imageUrl
        ? '<div class="bundle-components__image"><img src="' + escapeHtml(component.imageUrl) + '" alt="' + titleText + '" loading="lazy"></div>'
        : '<div class="bundle-components__image bundle-components__image--empty" aria-hidden="true"></div>';
    }

    var attrs = '';
    if (component.ingredients) {
      attrs +=
        '<div class="bundle-components__attribute bundle-components__ingredients">' +
        '<p class="bundle-components__attribute-label">Ingredients</p>' +
        '<p>' + escapeHtml(component.ingredients) + '</p>' +
        '</div>';
    }
    var allergensHtml = allergenIcons(component.allergens || '');
    if (allergensHtml) {
      attrs +=
        '<div class="bundle-components__attribute">' +
        '<p class="bundle-components__attribute-label">Allergen Info</p>' +
        allergensHtml +
        '</div>';
    }

    return (
      '<li class="bundle-components__item">' +
      imageHtml +
      '<div class="bundle-components__details">' +
      nameHtml +
      '<div class="bundle-components__attributes">' + attrs + '</div>' +
      '</div>' +
      '</li>'
    );
  }

  function componentList(components, options) {
    var rows = (components || []).map(function (c) { return componentRow(c, options); }).join('');
    return '<ul class="bundle-components__list" role="list">' + rows + '</ul>';
  }

  // Reorder normalized components to match `order` (an array of product handles).
  // The Storefront API does not expose a controllable bundle order, so we impose
  // one from a metafield. Components not present in `order` keep their original
  // (API) relative order and are appended at the end. A blank order is a no-op.
  function sortComponents(components, order) {
    var list = (components || []).slice();
    var orderList = order || [];
    if (!orderList.length) return list;

    var rankByHandle = {};
    for (var i = 0; i < orderList.length; i++) {
      if (!(orderList[i] in rankByHandle)) rankByHandle[orderList[i]] = i;
    }
    var unlistedRank = orderList.length;

    return list
      .map(function (component, index) { return { component: component, index: index }; })
      .sort(function (a, b) {
        var ra = a.component.handle in rankByHandle ? rankByHandle[a.component.handle] : unlistedRank;
        var rb = b.component.handle in rankByHandle ? rankByHandle[b.component.handle] : unlistedRank;
        if (ra !== rb) return ra - rb;
        return a.index - b.index; // stable tie-break: preserve original order
      })
      .map(function (entry) { return entry.component; });
  }

  return {
    allergenIcons: allergenIcons,
    componentRow: componentRow,
    componentList: componentList,
    sortComponents: sortComponents,
  };
});
